import { render, staticRenderFns } from "./dialog-create-inbox.vue?vue&type=template&id=697d9c18&scoped=true&"
import script from "./dialog-create-inbox.vue?vue&type=script&lang=js&"
export * from "./dialog-create-inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697d9c18",
  null
  
)

export default component.exports